import Vue from "vue";
import PrimeVue from "primevue/config";
import MultiSelect from "primevue/multiselect";
import Dropdown from "primevue/dropdown";

Vue.use(PrimeVue);
Vue.component("pv-multiselect", MultiSelect);
Vue.component("pv-dropdown", Dropdown);
